
<template>
    <!--T恤尺码-->
    <div id="sizeApp">
        <div class="app-dialog-mask" @click="close()"></div>
        <div id="apps" class="sku-wrap">
            <div class="header">
                <div class="img-wrap">
                    <img :src="thumbnail" class="j-summary-img" aria-label="选中的商品图">
                </div>
                <div class="main">
                    <div class="price-wrap">
                        <span class="price">¥{{productPrice}}</span>  
                    </div>   
                    <div class="stock">库存{{productQuantity}}件</div>   
                    <div class="sku-info" id="message">  <span>{{blackColor}} {{blackSize}}</span><br/><span>{{whiteColor}} {{whiteSize}} {{Sign}}</span>  </div>
                </div>
                <a class="sku-close" aria-label="关闭" @click="close()"></a>
            </div>
            <div class="body">
                <div class="body-item" >
                    <ul class="sku-list-wrap">
                        <li>
                            <h2 id="prop_title_0">主要颜色</h2>
                            <div class="items" id="items_0"> 
                                <a v-for="(item,index) in goodsMessage" :key="item.name" role="radio" :class="{'checked':index==curIndex,'disabled':hide}" @click="curIndex=index ,changeProduct(index)" href="javascript:void(0)" aria-checked="true">{{ item.name }}</a>
                            </div>
                        </li>
                        <li>
                            <h2 id="prop_title_1">尺码</h2>
                            <div class="items"  v-for="(items,index) in filterSize" :key="index"> 
                                <a role="radio"  v-for="(itemSize,indexSize) in items.productSize" :key="indexSize" :class="{'checked':indexSize==sizeIndex,'disabled':itemSize.sizeQuantity==0}" @click="sizeIndex=indexSize, chooseSize(indexSize)" href="javascript:void(0)" data-num="" aria-checked="true" >{{itemSize.size}}</a> 
                            </div>
                        </li>
                        <li>
                            <h2 id="prop_title_1">曹先生亲笔签名</h2>
                            <div class="items"> 
                                <a  v-for="(itemSign,indexSign) in signature" :key="itemSign.sign" role="radio" href="javascript:void(0)" :class="{'checked':indexSign==signIndex}" @click="signIndex=indexSign,chooseSign(indexSign)" data-value="" aria-checked="true" >{{itemSign.sign}}</a>
                            </div>
                        </li>
                    </ul>
                    <div class="number-wrap">
                        <div class="number-line">
                            <label for="number">购买数量</label>
                            <div class="number">
                                <button id="increase" class="decrease disabled" @click="changeCount(-1)">-</button>
                                <input id="number" type="number" :value="productNum">
                                <button class="increase"  @click="changeCount(1)">+</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer trade">
                <a class="ok " @click="sendConfirm()" role="button">确定</a>
            </div>
            <div id="points"><span id="pointMess"></span></div>
        </div>     
    </div> 

</template>

<script>
export default {
  data() {
    return {
      hide: false,
      productPrice: 338,
      productQuantity: 0,
      productNum: 1,
      blackColor: "已选择黑色",
      whiteColor: "",
      blackSize: "",
      whiteSize: "",
      curIndex: 0,
      signIndex: -1,
      sizeIndex: -1,
      thumbnail: "",
      Sign: "",
      point: "",
      signature: [{ sign: "有签名" }, { sign: "无签名" }],
      goodsMessage: [
        {
          name: "黑色",
          src:
            "http://www.artgogo.com/yishupin/images/2018/7/9/2018791531127882471_376_a.png",
          productSize: [
            {
              size: "165/S",
              sizeQuantity: 11
            },
            {
              size: "170/M",
              sizeQuantity: 326
            },
            {
              size: "175/L",
              sizeQuantity: 556
            },
            {
              size: "180/XL",
              sizeQuantity: 293
            },
            {
              size: "185/XXL",
              sizeQuantity: 0
            }
          ]
        },
        {
          name: "白色(赠品，不支持单拍)",
          src: "http://www.artgogo.com/newwap/new_wap/images/whiteT.png",
          productSize: [
            {
              size: "165/S",
              sizeQuantity: 6
            },
            {
              size: "170/M",
              sizeQuantity: 18
            },
            {
              size: "175/L",
              sizeQuantity: 1
            },
            {
              size: "180/XL",
              sizeQuantity: 26
            },
            {
              size: "185/XXL",
              sizeQuantity: 27
            }
          ]
        }
      ]
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.init();
    });
  },
  computed: {
    filterSize: function() {
      return this.goodsMessage.slice(this.curIndex, this.curIndex + 1);
    }
  },

  methods: {
    init: function() {
      this.thumbnail = this.goodsMessage[this.curIndex].src;
      var datas = this.goodsMessage;
      for (var i = 0; i < datas.length; i++) {
        for (var j = 0; j < datas[i].productSize.length; j++) {
          this.productQuantity += datas[i].productSize[j].sizeQuantity;
        }
      }
    },
    changeProduct: function(Index) {
      this.thumbnail = this.goodsMessage[Index].src;
      if (Index == 0) {
        //this.curIndex=0;
        this.blackColor = this.goodsMessage[Index].name;
      } else if (Index == 1) {
        //  this.curIndex=1;
        this.whiteColor = this.goodsMessage[Index].name;
      }
      this.chooseSize();
    },
    chooseSize: function(indexSize) {
      if (this.sizeIndex != -1) {
        this.changeQuantity();
      } else {
        return;
      }
      for (var i = 0; i < this.goodsMessage.length; i++) {
        for (var j = 0; j < this.goodsMessage[i].productSize.length; j++) {
          if (
            this.goodsMessage[i].productSize[this.sizeIndex].sizeQuantity == 0
          ) {
            document
              .getElementById("items_0")
              .childNodes.item(i)
              .classList.add("disabled");
          } else {
            document
              .getElementById("items_0")
              .childNodes.item(i)
              .classList.remove("disabled");
          }
        }
      }
      if (this.curIndex == 0) {
        this.blackSize = this.goodsMessage[this.curIndex].productSize[
          this.sizeIndex
        ].size;
      }
      if (this.curIndex == 1) {
        this.whiteSize = this.goodsMessage[this.curIndex].productSize[
          this.sizeIndex
        ].size;
      }
    },
    chooseSign: function(idx) {
      this.Sign = this.signature[idx].sign;
    },
    changeQuantity: function() {
      this.productQuantity = this.goodsMessage[this.curIndex].productSize[
        this.sizeIndex
      ].sizeQuantity;
    },
    sendConfirm: function() {
      if (this.blackColor == "" || this.blackSize == "") {
        this.maskShow("请选择黑色T恤尺码");
        return;
      }
      if (this.whiteColor == "" || this.whiteSize == "") {
        this.maskShow("请选择赠送白色T恤尺码");
        return;
      }
      if (this.Sign == "") {
        this.maskShow("请选择是否要签名");
        return;
      }
      window.location.href =
        "/newwap/new_wap/php/wap_confirm_order.php?art_id=31137&blackColor=" +
        encodeURI(this.blackColor) +
        "&blackSize=" +
        encodeURI(this.blackSize) +
        "&whiteColor=" +
        encodeURI(this.whiteColor) +
        "&whiteSize=" +
        encodeURI(this.whiteSize) +
        "&count=" +
        encodeURI(this.productNum) +
        "&sign=" +
        encodeURI(this.Sign);
    },
    maskShow: function(mess) {
      var timeDialog = "";
      clearTimeout(timeDialog);
      timeDialog = setTimeout(function() {
        document.getElementById("pointMess").innerHTML = mess;
        document.getElementById("points").style.display = "block";
        setTimeout(function() {
          document.getElementById("points").style.display = "none";
        }, 1500);
      }, 100);
    },
    changeCount: function(way) {
      if (way > 0) {
        this.productNum++;
        document.getElementById("increase").classList.remove("disabled");
      } else {
        this.productNum--;
        if (this.productNum < 2) {
          document.getElementById("increase").classList.add("disabled");
        }
        if (this.productNum < 1) {
          this.productNum = 1;
        }
      }
    },
    close: function() {
      document.getElementById("sizeApp").classList.remove("show-up");
    }
  }
};
</script>

<style lang="scss" scoped>
@charset "utf-8";
html {
  font-size: 100px;
}

@media (min-width: 320px) {
  html {
    font-size: 100px;
  }
}

@media (min-width: 360px) {
  html {
    font-size: 112.5px;
  }
}

@media (min-width: 400px) {
  html {
    font-size: 125px;
  }
}

@media (min-width: 640px) {
  html {
    font-size: 200px;
  }
}

body {
  background: #fff;
  font-size: 0.12rem;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
  height: 0;
}

html,
body,
form,
img,
ul,
ol,
li,
dl,
dt,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
b,
u,
i,
p,
em,
td,
th,
input,
textarea,
select,
iframe {
  font-family: "黑体", Arial, "simsun";
  /*font-family:"simsun";*/

  color: #191919;
  padding: 0;
  margin: 0;
  font-style: normal;
}

html* {
  outline: 0;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
  outline: 0;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

img {
  font-size: 0.06rem;
  vertical-align: middle;
}

input {
  outline: 0;
  border-radius: 0;
  -webkit-appearance: none;
  appearance: none;
  border: none;
}

td {
  font-family: Arial;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

ul li {
  vertical-align: bottom;
  padding: 0;
  margin: 0;
}

em i {
  font-style: normal;
}

li {
  list-style: none;
}

ol {
  list-style-type: none;
  list-style: none;
}

dd {
  margin-left: 0;
}

a img {
  border: 0;
}

h1 {
  font-size: 0.1rem;
}

h2,
h3 {
  font-size: 0.07rem;
  font-family: "黑体";
}

h4,
h5,
h6 {
  font-size: 0.06rem;
}

a {
  color: #191919;
  text-decoration: none;
  outline: 0;
}

a:active {
  text-decoration: none;
}

a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/*首页头部*/
body {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}

#sizeApp {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
}
#apps {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 20%;
  z-index: 2002;
  background: #fff;
  webkit-transform: translate3d(0, 105%, 0);
  transform: translate3d(0, 105%, 0);
  transition: all 300ms ease;
}
.app-dialog-mask {
  z-index: 2001;
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0;
  transition: all 300ms ease;
}

#sizeApp.show-up {
  z-index: 2000;
}
#sizeApp.show-up #apps {
  webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
#sizeApp.show-up .app-dialog-mask {
  opacity: 0.5;
}
#apps .header {
  position: relative;
  padding: 0.05rem 0.05rem 0.05rem 1.15rem;
}
#apps .header .img-wrap {
  width: 0.9rem;
  height: 0.9rem;
  position: absolute;
  top: -0.2rem;
  left: 0.1rem;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1px;
  background-color: #fff;
}
#apps .img-wrap img {
  width: 100%;
  margin-top: 15px;
}
#apps .header .main {
  color: #051b28;
  font-size: 12px;
  line-height: 18px;
  padding-right: 10px;
  font-family: "微软雅黑";
}
.sku-wrap .header .main .price {
  font-family: arial;
  font-size: 16px;
  word-wrap: break-word;
}
.sku-wrap .header .sku-close {
  position: absolute;
  top: 6px;
  right: 10px;
}
.sku-wrap .header .sku-close:after {
  content: "×";
  display: block;
  width: 20px;
  height: 20px;
  border: 1px solid #5f646e;
  border-radius: 100%;
  text-align: center;
  vertical-align: middle;
  line-height: 18px;
  color: #5f646e;
  position: absolute;
  right: 3px;
  top: 5px;
  font-size: 20px;
}
#message span {
  color: #fbc400;
}
.sku-wrap .body {
  padding: 0 15px 10px;
  position: absolute;
  bottom: 48px;
  top: 100px;
  left: 0;
  right: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.sku-wrap .body:before,
.signature:before {
  content: "";
  display: block;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.bundle-wrap li,
.sku-list-wrap li {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 10px;
}
.sku-wrap .body h2 {
  color: #666;
  font-size: 14px;
  font-weight: 400;
  padding-bottom: 10px;
  padding-top: 10px;
}
.bundle-wrap .items .checked,
.sku-list-wrap .items .checked {
  border-color: #fbc400;
  background: rgba(251, 196, 0, 0.1);
}
.bundle-wrap .items .disabled,
.sku-list-wrap .items .disabled {
  color: #cfcfcf;
  pointer-events: none;
}

.bundle-wrap .items a,
.sku-list-wrap .items a {
  position: relative;
  display: inline-block;
  border: 1px solid #f5f5f5;
  background-color: #f5f5f5;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  margin: 0 8px 8px 0;
  color: #555;
}
.number-wrap .number-line {
  padding-bottom: 10px;
  padding-top: 10px;
  line-height: 36px;
}
.number-wrap label {
  color: #666;
  font-size: 14px;
  font-weight: 400;
}
.number-wrap .number {
  height: 36px;
  width: 100px;
  border-radius: 3px;
  float: right;
}
.number-wrap .number .decrease {
  border-right: 1px solid #fff;
}

.number-wrap .number button {
  border: none;
  outline: 0;
  line-height: 32px;
  height: 34px;
  width: 30px;
  font-size: 24px;
  border: 1px solid #f5f5f5;
  background-color: #f5f5f5;
  padding: 0;
  color: #191919;
}
.number-wrap .number button,
.number-wrap .number input[type="number"] {
  float: left;
}
.number-wrap .number input[type="number"] {
  line-height: 32px;
  height: 34px;
  width: 36px;
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid #f5f5f5;
  background-color: #f5f5f5;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  margin: 0;
}
.number-wrap .number .increase {
  border-left: 1px solid #fff;
}
.number-wrap .number .disabled {
  color: #cfcfcf;
}
.sku-wrap .footer {
  display: block;
  display: -webkit-box;
  display: flex;
  height: 48px;
  text-align: center;
  line-height: 48px;
  color: #fff;
  width: 100%;
  position: absolute;
  bottom: 0;
}
.sku-wrap .footer .ok {
  display: block;
  font-size: 15px;
  line-height: 50px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  color: #fff;
  background: -webkit-linear-gradient(
    to right,
    rgba(244, 218, 123, 1),
    rgba(251, 197, 3, 1)
  );
  background: -o-linear-gradient(
    to right,
    rgba(244, 218, 123, 1),
    rgba(251, 197, 3, 1)
  );
  background: -moz-linear-gradient(
    to right,
    rgba(244, 218, 123, 1),
    rgba(251, 197, 3, 1)
  );
  background: linear-gradient(
    to right,
    rgba(244, 218, 123, 1),
    rgba(251, 197, 3, 1)
  );
  background: linear-gradient(
    to right,
    rgba(244, 218, 123, 1),
    rgba(251, 197, 3, 1)
  );
}
#points {
  display: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  margin: auto;
}
#pointMess {
  padding: 20px 20px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  border-radius: 6px;
}
</style>